export default {
    baseStyle: {
        body: {
            padding: {base: '24px 16px 8px'}
        },
        title: {
            textStyle: 'webH2'
        },
        description: {
            textStyle: 'bodySmRegular'
        },
        label: {
            textStyle: 'webH3'
        },
        link: {
            display: 'block',
            h: 'auto',
            minH: 'auto',
            textAlign: 'left',
            textStyle: 'bodySmLink'
        },
        radio: {
            alignItems: 'center'
        },
        addressDisplay: {
            textStyle: 'bodySmRegular'
        }
    },
    variants: {
        noCloseMatch: {
            body: {
                padding: {base: '24px 16px'}
            }
        },
        poBoxMilitary: {
            body: {
                padding: {base: '24px 16px 14px'}
            }
        },
        geoMismatch: {
            body: {
                padding: {base: '24px 16px 30px'}
            }
        },
        geoMismatchNested: {
            body: {
                padding: 0
            }
        }
    }
}
